import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type BulkApplySupervisorRdPercentageAnalyticIds = {
  generatePreviewBtnId: string;
  downloadPreviewBtnId: string;
  cancelBtnId: string;
  applyBtnId: string;
};

export const useBulkApplySupervisorRdPercentageAnalyticIds = (): BulkApplySupervisorRdPercentageAnalyticIds => ({
  generatePreviewBtnId: useAnalyticId(AnalyticIdentifier.SUPERVISOR_RD_PERCENTAGE_MODAL_GENERATE_PREVIEW_BTN),
  downloadPreviewBtnId: useAnalyticId(AnalyticIdentifier.SUPERVISOR_RD_PERCENTAGE_MODAL_DOWNLOAD_PREVIEW_BTN),
  cancelBtnId: useAnalyticId(AnalyticIdentifier.SUPERVISOR_RD_PERCENTAGE_MODAL_CANCEL_BTN),
  applyBtnId: useAnalyticId(AnalyticIdentifier.SUPERVISOR_RD_PERCENTAGE_MODAL_APPLY_BTN),
});
